import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { PATH } from '../constants/path.constant';
import { clearAuth } from '../utils/auth';

function AdminLogoutButton({ variant = 'outline-danger', size, className }) {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogout = () => {
    clearAuth();
    // Clean up legacy keys from the hardcoded-token era so logouts
    // don't leave half-stale state behind for old browsers.
    try {
      localStorage.removeItem('user-token');
    } catch (_) { /* noop */ }
    window.location.href = PATH.ADMIN.LOGIN;
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => setShowConfirm(true)}
      >
        Đăng xuất
      </Button>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Xác nhận đăng xuất</Modal.Title>
        </Modal.Header>
        <Modal.Body>Bạn có chắc chắn muốn đăng xuất khỏi hệ thống?</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirm(false)}>
            Huỷ
          </Button>
          <Button variant='danger' onClick={handleLogout}>
            Đăng xuất
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AdminLogoutButton;
